<template>
	<eg-modal
		height="300px"
		width="800px"
		:show="show"
		@close="$emit('close', false)"
	>
		<p class="center" slot="header"><b>Remoção de rascunho</b></p>
		<p slot="body">
			Tem certeza que você quer apagar esse rascunho?
		</p>
		<div slot="footer">
			<a
				@click="$emit('close', false)"
				class="modal-action footer-btn  modal-close btn blue accent-1"
				>Não</a
			>
			<a
				id="positive-answer"
				class="modal-action footer-btn  btn blue darken-4"
				@click="removeDraft"
				>Sim</a
			>
		</div>
	</eg-modal>
</template>

<script>
import {removeDraft} from '@/services/';
export default {
    name: 'RemoveDraftConfirm',
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        draftId: {
            type: Number,
            default: 0,
        },
        token: {
            type: String,
            default: '',
        },
    },
    methods: {
        async removeDraft() {
            const {success} = await removeDraft(this.draftId);
            if (success) {
                this.$emit('remove', this.draftId);
                this.$emit('close', false);
            } else {
                alert('erro interno');
                this.$emit('close', false);
            }
        },
    },
};
</script>

<style>
.footer-btn {
	margin-right: 20px;
}
</style>
